// Wrapper to ensure TomSelect is properly exported for webpack 4
// The UMD build sets window.TomSelect as a side-effect
require('tom-select/dist/js/tom-select.complete.js');
module.exports = window.TomSelect;
